import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { canSendFilterEngagement } from './filterEngagementGate';
import { GA4ContentClickEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';

export class GtmPlatformFilterClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        // With the engagement flag on, the deferred merged custEv_contentClick
        // (GtmFilterClickType, elementType platformFilterEngagement) carries this
        // event's fields plus the AI fields, so stand down to avoid a duplicate
        // GA4 push. Marketing's Platform Filter Click event is unaffected.
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            event.elementType === 'platformFilter' &&
            !canSendFilterEngagement()
        );
    }

    getBody(event: GTMBaseEvent): GA4ContentClickEvent {
        return {
            event: 'custEv_contentClick',
            element_type: 'platformFilter',
            click_text: String(event.platform ?? ''),
            content_category: String(event.eventAction ?? ''),
        };
    }
}
